export default {
  setShopItemList: (state, list) => {
    state.shopItemList = list;
  },
  setBuyMemorialList: (state, list) => {
    state.buyMemorialItemList = list;
  },
  setCategoryShopList: (state, list) => {
    state.categoryShopList = list;
  },
  setUserItemCondition: (state, condition) => {
    Object.assign(state.userItemCondition, condition);
  },
  InitUserItem: state => {
    state.userItemList = [];
    state.userItemCondition.page = 1;
    state.userItemCondition.userNo = '';
    state.userItemCondition.category = '';
    state.userItemCondition.limit = 10;
    state.userPageInfo.totalPage = 2;
  },
  setUserItemList: (state, { list, category }) => {
    state.userItemList = [...state.userItemList, ...list];
  },

  setUserPageInfo: (state, pageInfo) => {
    Object.assign(state.userPageInfo, pageInfo);
  },

  setList: (state, list) => {
    state.list = list;
  }
};
